import { gql } from '@apollo/client'

export default gql`
  mutation createBuyerLeadVisitInterest(
    $id: ID!
    $interestInput: InterestInput!
    $mainInterest: MainInterests
    $paymentType: BuyerPaymentType
    $hasApprovedCredit: Boolean
    $cpf: String
    $incomeMonthly: Decimal
    $creditTotalValue: Decimal
    $listingAnnounced: Boolean
  ) {
    editUserProfile(
      id: $id
      mainInterest: $mainInterest
      paymentType: $paymentType
      hasApprovedCredit: $hasApprovedCredit
      cpf: $cpf
      incomeMonthly: $incomeMonthly
      creditTotalValue: $creditTotalValue
      listingAnnounced: $listingAnnounced
    ) {
      id
      cpf
      paymentType
      hasApprovedCredit
      listingAnnounced
      incomeMonthly
      creditTotalValue
      buyerIntent {
        mainInterest
      }
    }
    interestCreate(input: $interestInput) {
      id
      uuid
      credentials {
        jwt
        user {
          name
          id
          email
          phone
          role
        }
      }
    }
  }
`
